import {useRef, useState} from 'react';
import Modal from '../../components/modal_dialog';
import FormAsyncSelect from '../../components/form-async-select';
import {fetch} from '../../utils/api-wrapper';

// Keep this single-approver request separate from editing the invoice or its workflow.
export default function RequestAnotherApprovalModal({data, approvalRequest, onClose, onSuccess}) {
    const [approver, setApprover] = useState(null);
    const [sending, setSending] = useState(false);
    const [error, setError] = useState(null);
    const inFlight = useRef(false);
    const t = (key) => data.t.read(key);
    const submit = () => {
        if (!approver?.value || inFlight.current) return false;
        inFlight.current = true;
        setSending(true);
        setError(null);
        const payload = {
            invoice_id: approvalRequest.invoice_id,
            type: approvalRequest.type,
            approver_id: approver.value,
            ...(approvalRequest.type === 'line_item' ? {
                line_item_key: approvalRequest.line_item_key || approvalRequest.line_id || approvalRequest.line_item_view_id,
            } : {}),
        };
        fetch('/approvals/approved/request', 'POST', payload, () => {
            inFlight.current = false;
            setSending(false);
            onSuccess();
        }, response => {
            inFlight.current = false;
            setSending(false);
            const code = response?.response?.data?.error;
            const key = ['approval_already_pending', 'approval_not_currently_approved'].includes(code)
                ? 'approval_modal.another_request_stale'
                : code === 'invalid_approver' ? 'approval_modal.another_request_invalid_approver'
                    : 'approval_modal.another_request_error';
            setError(t(key));
        });
        // The modal's loading state follows the request, including failed retries.
        return false;
    };
    return <Modal
        title={t('approval_modal.request_another_approval')}
        okText={t('approval_modal.send_request')}
        okAction={submit}
        invalid={!approver?.value || sending}
        noProcessingLoading
        okLoading={sending}
        closeDisabled={sending}
        zIndex={1050}
        cancelText={t('cancel')}
        cancelAction={() => { if (!inFlight.current) onClose(); }}
        disableBackdropClose={sending}
    >
        <label htmlFor="another-approver">{t('approver')}</label>
        <FormAsyncSelect
            data={data}
            inputId="another-approver"
            name="another-approver"
            searchUrl="/client/users/approvers/search"
            placeholder={t('approver')}
            value={approver}
            isDisabled={sending}
            isClearable
            // Give this standalone picker a visible boundary inside the modal.
            stylesOverride={{control: base => ({...base, border: '1px solid #ced4da', borderRadius: 4})}}
            // The shared picker maps both API users and its controlled selection.
            // Keep the existing option label when mapping the selection back in.
            optionMap={user => user ? {
                value: user.id_user ?? user.value,
                label: user.label || [user.first_name, user.last_name].filter(Boolean).join(' ') || user.username,
            } : null}
            onChange={setApprover}
        />
        {error && <div role="alert" className="alert alert-danger mt-3">{error}</div>}
    </Modal>;
}
